import _objectSpread from "D:/mzkj/\u8981\u70BC/yl-pc-business/node_modules/@babel/runtime/helpers/esm/objectSpread2";
import "regenerator-runtime/runtime";
import _asyncToGenerator from "D:/mzkj/\u8981\u70BC/yl-pc-business/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
export default {
  meta: {
    title: '管理属性值',
    auth: true,
    authorityValue: "store-goods-sellatt"
  },
  name: 'saleSet',
  data: function data() {
    return {
      list: {},
      rules: {},
      form: {}
    };
  },
  created: function created() {
    this.dataBind(this.$route.query);
  },
  methods: {
    dataBind: function dataBind(item) {
      var _this = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var res;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return _this.$api.sellAttributeDetails(_objectSpread({}, item));

              case 2:
                res = _context.sent;
                _this.list = res;

              case 4:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }))();
    },
    clickBack: function clickBack(row) {
      this.$set(row, 'status', false);
      this.dataBind(this.$route.query);
    },
    clickSave: function clickSave(row) {
      var _this2 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                if (row.itemValue) {
                  _context2.next = 2;
                  break;
                }

                return _context2.abrupt("return", _this2.$notify.error({
                  title: '错误',
                  message: '属性值名称不可为空'
                }));

              case 2:
                _context2.next = 4;
                return _this2.$api.saveSellAttributeItem(row);

              case 4:
                _this2.$set(row, 'status', false);

                setTimeout(function () {
                  _this2.dataBind(_this2.$route.query);
                }, 100);

              case 6:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }))();
    },
    clickAdd: function clickAdd() {
      this.list.items.unshift({
        sellAttributeId: this.$route.query.sellAttributeId,
        itemValue: '',
        itemSort: '',
        status: true
      });
    }
  }
};